export default __webpack_public_path__ + "images/0xc7346783f5e645aa998b106ef9e7f499528673d8.png";